<template>
    <div>
        <b-card
            class="form-card p-0 p-sm-2 d-flex flex-column justify-content-between"
            body-class="d-flex flex-row justify-content-between align-items-center"
        >
            <b-form-row class="flex-fill">
                <b-col
                    cols="12"
                    md="8"
                >
                    <div class="mr-2 wrap-anywhere">
                        <div class="d-flex p-1 buttons-wrapper align-items-center justify-content-center w-100">
                            <div class="d-none d-sm-flex">
                                <i class="fal fa-file-alt text-primary form-icon"/>
                            </div>
                            <div class="d-flex flex-shrink-0 flex-column px-0 px-sm-4 flex-row align-items-start w-100">
                                <div class="form-title">
                                    {{ form.officialName }}
                                </div>
                                <template v-if="form.formAuthor">
                                    <div class="form-author">
                                        {{ form.formAuthor.name }}
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col
                    class="text-right align-self-center"
                    cols="12"
                    md="4"
                >
                    <template>
                        <b-button
                            pill
                            class="white-button"
                            @click="displayForm"
                        >
                            {{ !fromEmail ? 'View' : 'Download' }}
                        </b-button>
                    </template>
                </b-col>
            </b-form-row>
        </b-card>

    </div>
</template>

<script>
import './FormCard.scss';
import FormAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/FormAppResource";

export default {
    name: 'FormCard',
    props: {
        form: {
            type: FormAppResource,
            required: true,
        },
        fromEmail: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {},
    methods: {
        async displayForm() {
            this.$emit('display', this.form);
        },
    }
};
</script>
